import { AreaUpdateForm, BuildingsManager } from 'components/Pages/Areas';
import { SettingsMenu } from 'components/Shared';
import { Scaffold } from 'layouts';
import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as S from './styles';

export const AreaDetailPage: React.FC = () => {
  const { areaId } = useParams() as { areaId: string };
  const navigate = useNavigate();
  const onUpdate = useCallback(
    () => navigate('/configuracoes/areas'),
    [navigate]
  );

  return (
    <Scaffold>
      <SettingsMenu />
      <S.PageContainer>
        <AreaUpdateForm areaId={areaId} onUpdate={onUpdate} />
        <BuildingsManager areaId={areaId} />
      </S.PageContainer>
    </Scaffold>
  );
};
